import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
  IonFooter,
  IonButton,
  IonIcon,
  IonThumbnail,
  IonImg,
} from '@ionic/react';
import { chevronBackOutline } from 'ionicons/icons';
import './PageLayout.css';

function Layout({
  title,
  children,
  footer,
  hasMenu,
  back,
  header,
  wrapContent,
  hideHeader,
}) {
  const history = useHistory();
  const handleBack = () => {
    if (back === true) {
      history.goBack();
    } else {
      history.replace(back);
    }
  };

  return (
    <IonPage>
      {!hideHeader && (
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              {hasMenu && !back && <IonMenuButton />}
              {back && (
                <IonButton onClick={handleBack}>
                  <IonIcon slot="icon-only" icon={chevronBackOutline} />
                </IonButton>
              )}
            </IonButtons>
            <IonTitle>{title}</IonTitle>
            {header}
            {!header && (
              <IonThumbnail slot="end">
                <IonImg src="/assets/vemospay-white-logo.png" />
              </IonThumbnail>
            )}
          </IonToolbar>
        </IonHeader>
      )}

      {wrapContent ? <IonContent>{children}</IonContent> : children}

      {footer && <IonFooter className="ion-no-border">{footer}</IonFooter>}
    </IonPage>
  );
}

Layout.propTypes = {
  hideHeader: PropTypes.bool,
  hasMenu: PropTypes.bool,
  back: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  title: PropTypes.node,
  footer: PropTypes.node,
  children: PropTypes.node,
  wrapContent: PropTypes.bool,
  header: PropTypes.node,
};

Layout.defaultProps = {
  hideHeader: false,
  wrapContent: true,
  hasMenu: true,
};

export default Layout;
